import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import MainView from '../components/MainView/MainView'

import {
  setMerchantModalData,
  setMerchantModalStatus,
} from '../../../modules/explore/actions/creators'

import {
  waitRenderServer,
  renderServer,
} from '../../../modules/ssr/actions/creators'

import { setFirebaseMessagingToken } from '../../../modules/auth/actions/creators'

import { setError, removeError } from '../../../modules/errors/actions/creators'

import { withFirebase } from '../../../components/accessibility/Firebase/Firebase'

import { setAccountStatus } from '../../../modules/profile/actions/creators'

import {
  doSubscribeToFirebaseMessaging,
  doSubscribeToFirebaseGuest,
} from '../../../controllers/Firebase'

const mapStateToProps = reduxState => {
  const { explore, auth, errors, profile } = reduxState
  const { accessToken, firebaseMessagingToken } = auth
  const { showMerchantModal, merchantModalData, merchantModalStatus } = explore
  const { errorList } = errors
  const { advanceAccount, preferenceIds } = profile

  return {
    accessToken,
    preferenceIds,
    errorList,
    showMerchantModal,
    merchantModalData,
    merchantModalStatus,
    firebaseMessagingToken,
    doSubscribeToFirebaseMessaging,
    doSubscribeToFirebaseGuest,
    advanceAccount,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setMerchantModalData,
      setMerchantModalStatus,
      setError,
      removeError,
      push,
      waitRenderServer,
      renderServer,
      setFirebaseMessagingToken,
      setAccountStatus,
    },
    dispatch,
  )

const ConnectedMainView = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withFirebase(MainView))

export default ConnectedMainView
